import {ReactionEmojiComponent} from './reaction-emoji.component';
import {SpinnerModule} from '../spinner/spinner.module';
import {TypingIndicatorComponent} from './typing-indicator.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {InputTextModule} from 'primeng/inputtext';
import {SocialInputComponent} from './social-input/social-input.component';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {RxReactiveFormsModule} from '@rxweb/reactive-form-validators';
import {FileUploadModule} from 'primeng/fileupload';
import {PipesModule} from '../../core/pipes/pipes.module';
import {SocialReactionsBarComponent} from './social-reactions-bar/social-reactions-bar.component';
import {EmojiModule} from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {PickerModule} from '@ctrl/ngx-emoji-mart';
import {TiptapEditorDirective} from "ngx-tiptap";
import {VirtualScrollerModule} from "primeng/virtualscroller";
import {SkeletonModule} from "primeng/skeleton";
import {NativeVideoPreviewModule} from "../media/native-video-preview/native-video-preview.module";
import {TranslateModule} from '@ngx-translate/core';
@NgModule({
  imports: [
    CommonModule,
    ReactionEmojiComponent,
    TypingIndicatorComponent,
    OverlayPanelModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    InputTextareaModule,
    RxReactiveFormsModule,
    FileUploadModule,
    PipesModule,
    EmojiModule,
    PickerModule,
    TiptapEditorDirective,
    VirtualScrollerModule,
    SkeletonModule,
    SpinnerModule,
    NativeVideoPreviewModule,
    TranslateModule
  ],
  declarations: [SocialInputComponent, SocialReactionsBarComponent],
  exports: [SocialInputComponent, SocialReactionsBarComponent, ReactionEmojiComponent],
})
export class SocialModule {
}
